export const translations = {
  ar: {
    dir: "rtl",
    brand: "SbPay",
    tagline: "محفظتك الرقمية السريعة والآمنة",
    signInGoogle: "تسجيل الدخول عبر Google",
    signingIn: "جارِ تسجيل الدخول...",
    loginBullet1: "أرسل واستقبل الأموال فوراً",
    loginBullet2: "ادفع عبر رمز QR بكل سهولة",
    loginBullet3: "تتبّع كل عملية في مكان واحد",
    currency: "ر.س",
    balance: "الرصيد المتاح",
    walletNumber: "رقم المحفظة",
    hide: "إخفاء",
    show: "إظهار",
    send: "إرسال",
    request: "طلب",
    add: "شحن",
    scan: "مسح QR",
    quickActions: "إجراءات سريعة",
    recentActivity: "النشاط الأخير",
    viewAll: "عرض الكل",
    noActivity: "لا توجد عمليات بعد",
    noActivitySub: "ابدأ بشحن محفظتك أو إرسال الأموال",
    myCard: "بطاقتي",
    sbpayCard: "بطاقة SbPay",
    addMoney: "شحن المحفظة",
    addMoneyDesc: "أضف رصيداً إلى محفظتك بأمان",
    amount: "المبلغ",
    enterAmount: "أدخل المبلغ",
    confirm: "تأكيد",
    cancel: "إلغاء",
    sendMoney: "إرسال الأموال",
    sendMoneyDesc: "أرسل إلى أي مستخدم عبر المعرّف أو رقم الجوال",
    recipient: "المستلم",
    recipientPlaceholder: "@المعرّف أو رقم الجوال",
    note: "ملاحظة (اختياري)",
    notePlaceholder: "مثال: غداء، إيجار...",
    requestMoney: "طلب الأموال",
    requestMoneyDesc: "اطلب مبلغاً من مستخدم آخر ليوافق عليه",
    requestFrom: "اطلب من",
    scanToPay: "مسح للدفع",
    scanToPayDesc: "أدخل معرّف المستخدم من رمز QR للدفع له",
    myQr: "رمز QR الخاص بي",
    receiveTab: "استقبال",
    payTab: "دفع",
    qrReceiveDesc: "اطلب من الآخرين مسح الرمز لإرسال الأموال إليك",
    copyHandle: "نسخ المعرّف",
    copied: "تم النسخ",
    pendingRequests: "طلبات معلّقة",
    requestedFromYou: "طلب منك",
    pay: "دفع",
    decline: "رفض",
    requestsYouSent: "طلباتك المرسلة",
    status_pending: "معلّق",
    status_approved: "مدفوع",
    status_declined: "مرفوض",
    logout: "تسجيل الخروج",
    profile: "الملف الشخصي",
    mobileNumber: "رقم الجوال",
    mobilePlaceholder: "05XXXXXXXX",
    save: "حفظ",
    transactionDetails: "تفاصيل العملية",
    type_topup: "شحن المحفظة",
    type_send: "إرسال أموال",
    type_receive: "استلام أموال",
    type_request_pay: "دفع طلب",
    date: "التاريخ",
    reference: "المرجع",
    to: "إلى",
    from: "من",
    completed: "مكتملة",
    sent: "تم إرسال",
    received: "تم استلام",
    toastSent: "تم إرسال الأموال بنجاح",
    toastTopup: "تم شحن المحفظة بنجاح",
    toastRequested: "تم إرسال الطلب",
    toastPaid: "تم الدفع بنجاح",
    toastDeclined: "تم رفض الطلب",
    toastHandleCopied: "تم نسخ المعرّف",
    toastProfileSaved: "تم حفظ الملف الشخصي",
    errorGeneric: "حدث خطأ ما",
    greeting: "مرحباً",
    payByCard: "الدفع بالبطاقة",
    instantDemo: "فوري (تجريبي)",
    cardTopupDesc: "اختر المبلغ وادفع بمدى أو فيزا أو ماستركارد",
    redirecting: "جارِ التحويل إلى الدفع...",
    processingPayment: "جارِ تأكيد الدفع...",
    paymentSuccess: "تم الدفع بنجاح",
    paymentSuccessDesc: "تمت إضافة الرصيد إلى محفظتك",
    paymentCancelled: "تم إلغاء الدفع",
    paymentCancelledDesc: "لم تتم أي عملية دفع",
    backToWallet: "العودة إلى المحفظة",
    more: "المزيد",
    bills: "الفواتير",
    recharge: "شحن الجوال",
    split: "تقسيم الفاتورة",
    billsRecharge: "الفواتير والشحن",
    billsDesc: "ادفع فواتيرك أو اشحن جوالك من رصيد المحفظة",
    selectBiller: "اختر المزود",
    accountNumber: "رقم الحساب / الجوال",
    accountNumberPlaceholder: "أدخل رقم الحساب أو الجوال",
    toastBillPaid: "تم دفع الفاتورة بنجاح",
    toastRecharged: "تم شحن الجوال بنجاح",
    category_telecom: "اتصالات",
    category_utility: "خدمات",
    category_internet: "إنترنت",
    type_bill: "دفع فاتورة",
    type_recharge: "شحن جوال",
    splitBillTitle: "تقسيم الفاتورة",
    splitDesc: "قسّم الفاتورة مع أصدقائك وأرسل لكل منهم حصته",
    splitTitlePlaceholder: "مثال: عشاء، رحلة...",
    totalAmount: "المبلغ الإجمالي",
    participants: "المشاركون",
    addParticipantPlaceholder: "@المعرّف أو رقم الجوال",
    addBtn: "إضافة",
    includeMe: "أنا مشارك في التقسيم",
    perPerson: "لكل شخص",
    sendRequests: "إرسال الطلبات",
    toastSplitSent: "تم إرسال طلبات التقسيم",
    orDivider: "أو",
    phoneLogin: "الدخول برقم الجوال",
    enterPhoneTitle: "أدخل رقم جوالك",
    enterPhoneDesc: "سنرسل لك رمز تحقق لمرة واحدة",
    phonePlaceholder: "05XXXXXXXX",
    sendCode: "إرسال الرمز",
    enterCodeTitle: "أدخل رمز التحقق",
    enterCodeDesc: "أدخل الرمز المكوّن من 6 أرقام",
    verifyCode: "تحقق ودخول",
    resendCode: "إعادة إرسال الرمز",
    changeNumber: "تغيير الرقم",
    demoCodeHint: "رمزك التجريبي",
    backToGoogle: "رجوع",
    continueWithEmail: "المتابعة بالبريد الإلكتروني",
    loginTab: "تسجيل الدخول",
    registerTab: "حساب جديد",
    fullName: "الاسم الكامل",
    emailLabel: "البريد الإلكتروني",
    passwordLabel: "كلمة المرور",
    namePlaceholder: "اكتب اسمك",
    emailPlaceholder: "you@example.com",
    passwordPlaceholder: "٦ أحرف على الأقل",
    signInBtn: "دخول",
    registerBtn: "إنشاء الحساب",
    downloadStatement: "تنزيل كشف الحساب (CSV)",
    toastStatementReady: "تم تنزيل كشف الحساب",
    autoReload: "الشحن التلقائي الشهري",
    autoReloadDesc: "اشحن محفظتك تلقائياً كل شهر",
    autoReloadAmount: "مبلغ الشحن الشهري",
    toastAutoReloadSaved: "تم حفظ إعداد الشحن التلقائي",
    bankTransfer: "تحويل بنكي",
    bankTransferDesc: "حوّل إلى أي حساب بنكي سعودي عبر الآيبان",
    selectBank: "اختر البنك",
    beneficiaryName: "اسم المستفيد",
    beneficiaryPlaceholder: "الاسم كما في الحساب البنكي",
    ibanLabel: "رقم الآيبان (IBAN)",
    ibanPlaceholder: "SA00 0000 0000 0000 0000 0000",
    transferBtn: "تحويل",
    toastBankTransfer: "تم تنفيذ التحويل البنكي (قيد المعالجة)",
    type_bank_transfer: "تحويل بنكي",
    status_processing: "قيد المعالجة",
    myIban: "آيبان محفظتي",
    nationalId: "رقم الهوية الوطنية",
    nationalIdPlaceholder: "1xxxxxxxxx",
    mobileOptional: "رقم الجوال (اختياري)",
    cardControls: "التحكم بالبطاقة",
    cardControlsDesc: "جمّد بطاقتك أو حدّد سقف الإنفاق اليومي",
    freezeCard: "تجميد البطاقة",
    freezeCardDesc: "إيقاف جميع عمليات الدفع من البطاقة مؤقتاً",
    cardFrozen: "البطاقة مجمّدة",
    cardActive: "البطاقة نشطة",
    dailyLimit: "سقف الإنفاق اليومي",
    dailyLimitDesc: "الحد الأقصى للإنفاق خلال اليوم الواحد",
    noLimit: "بدون حد",
    spentToday: "المصروف اليوم",
    remainingToday: "المتبقي اليوم",
    manageCard: "إدارة",
    toastCardUpdated: "تم تحديث إعدادات البطاقة",
    internationalTransfer: "تحويل دولي",
    intlTransferDesc: "أرسل الأموال للخارج عبر شريك تحويلات مرخّص",
    destinationCountry: "دولة الوجهة",
    transferMethod: "طريقة التحويل",
    recipientGets: "يستلم المستفيد",
    transferFee: "رسوم التحويل",
    totalDebit: "إجمالي الخصم",
    sendAbroad: "إرسال للخارج",
    toastIntlTransfer: "تم إرسال التحويل الدولي (قيد المعالجة)",
    type_intl_transfer: "تحويل دولي",
    exchangeRate: "سعر الصرف",
    insights: "تحليل المصروفات",
    insightsDesc: "ملخص دخلك ومصروفاتك حسب الفئة",
    income: "الدخل",
    spending: "المصروفات",
    net: "الصافي",
    noInsights: "لا توجد عمليات في هذه الفترة",
    txCount: "عملية",
    thisMonth: "هذا الشهر",
    allTime: "كل الفترات",
    trackTransfer: "تتبع التحويل",
    step_submitted: "تم الإرسال",
    step_processing: "قيد المعالجة",
    step_in_transit: "قيد التحويل",
    step_ready: "جاهز للاستلام",
    delivered: "تم التسليم",
    reference: "الرقم المرجعي",
    shareReceipt: "مشاركة الإيصال",
    copyReceiptLink: "نسخ رابط الإيصال",
    receiptCopied: "تم نسخ رابط الإيصال",
    remittanceReceipt: "إيصال التحويل الدولي",
    estimatedArrival: "الوقت المتوقع",
    setPin: "تعيين رمز PIN",
    changePin: "تغيير رمز PIN",
    cardPin: "رمز البطاقة السري",
    cardPinDesc: "رمز من 4 أرقام لحماية إجراءات البطاقة",
    enterPin: "أدخل رمز PIN",
    currentPin: "الرمز الحالي",
    newPin: "الرمز الجديد",
    confirmPin: "تأكيد الرمز",
    pinMismatch: "الرمزان غير متطابقين",
    revealCard: "إظهار بيانات البطاقة",
    hideDetails: "إخفاء البيانات",
    cardNumber: "رقم البطاقة",
    expiry: "تاريخ الانتهاء",
    cvv: "رمز التحقق",
    reissueCard: "إصدار بطاقة جديدة",
    reissueDesc: "استبدال رقم البطاقة الحالي برقم جديد",
    reissueConfirm: "هل تريد إصدار بطاقة جديدة؟ سيتوقف الرقم الحالي.",
    unlockCard: "أدخل رمز PIN لإدارة البطاقة",
    toastPinSet: "تم حفظ رمز PIN",
    toastReissued: "تم إصدار بطاقة جديدة بنجاح",
    pinProtected: "محمية برمز PIN",
    sentVia: "عبر",
    amountSent: "المبلغ المرسل",
    poweredBy: "مدعوم من",
    txType: "النوع",
    status: "الحالة",
    financing: "التمويل الفوري",
    financingDesc: "احصل على سيولة فورية وسدّدها على 4 أقساط بدون فوائد",
    financingBanner: "تمويل فوري حتى 5,000 ر.س",
    financingBannerSub: "تحقق فوري عبر نفاذ · 4 أقساط · 0% رسوم",
    chooseAmount: "اختر المبلغ",
    chooseProvider: "اختر مزوّد التمويل",
    applyNow: "تقديم الطلب",
    installmentsPlan: "4 أقساط شهرية",
    zeroFee: "بدون رسوم",
    monthlyInstallment: "القسط الشهري",
    nafathTitle: "التحقق عبر نفاذ",
    nafathInstruction: "افتح تطبيق نفاذ واختر الرقم التالي للتحقق من هويتك",
    selectThisNumber: "اختر هذا الرقم في تطبيق نفاذ",
    verifying: "جارٍ التحقق…",
    simulationMode: "وضع المحاكاة (لا يوجد ربط حقيقي بنفاذ)",
    financingApproved: "تمت الموافقة على التمويل",
    cashAddedDesc: "تمت إضافة المبلغ إلى محفظتك فوراً",
    activeFinancing: "التمويلات النشطة",
    noFinancing: "لا توجد تمويلات نشطة",
    newFinancing: "تمويل جديد",
    repay: "سداد",
    repayInstallment: "سداد القسط",
    installment: "القسط",
    due: "الاستحقاق",
    paidLabel: "مدفوع",
    remaining: "المتبقي",
    allPaid: "تم سداد جميع الأقساط",
    financingRejected: "تعذّر إكمال التحقق",
    tryAgain: "إعادة المحاولة",
    poweredByNafath: "تحقق الهوية عبر نفاذ",
    type_financing: "تمويل",
    type_financing_repay: "سداد قسط",
    accountType: "نوع الحساب",
    individual: "فرد",
    business: "منشأة",
    crNumber: "السجل التجاري",
    crPlaceholder: "10 أرقام",
    nafathVerifyNote: "يتم التحقق من الهوية عبر نفاذ قبل إنشاء الحساب",
    addToWallet: "أضف إلى المحفظة",
    applePay: "Apple Pay",
    madaPay: "مدى Pay",
    samsungWallet: "Samsung Wallet",
    added: "تمت الإضافة",
    toastWalletLinked: "تمت إضافة البطاقة إلى المحفظة",
    adminPanel: "لوحة العملاء",
    adminCustomers: "إدارة العملاء",
    totalCustomers: "إجمالي العملاء",
    searchCustomers: "بحث بالاسم أو المعرّف أو الهوية",
    verifiedLabel: "موثّق",
    unverifiedLabel: "غير موثّق",
    viewCustomers: "عرض العملاء",
    frozenLabel: "مجمّدة",
    navHome: "الرئيسية",
    financingShort: "التمويل",
    navActivity: "العمليات",
    navCard: "البطاقة",
    navProfile: "حسابي",
    navAdmin: "الإدارة",
    comingSoon: "قريباً",
    comingSoonDesc: "هذه الخدمة غير متاحة بعد. سنفعّلها بعد ربطها بشريك مرخّص.",
    testMode: "وضع الاختبار",
    testModeNote: "عمليات الشحن بالبطاقة في وضع الاختبار ولا تُخصم أموال حقيقية",
    topupNotConfigured: "الشحن بالبطاقة غير متاح حالياً",
    topupNotConfiguredDesc: "لم يتم ربط بوابة دفع بعد. يمكنك استلام الأموال من مستخدمي SB Pay الآخرين.",
    payWithPayPal: "PayPal",
    paypalNote: "يتم الدفع بالدولار الأمريكي (1 دولار = 3.75 ريال)",
    servicesTitle: "الخدمات",
    loadError: "تعذّر تحميل البيانات",
    retry: "إعادة المحاولة",
    loadMore: "عرض المزيد",
    filterAll: "الكل",
    filterIn: "وارد",
    filterOut: "صادر",
    searchActivity: "ابحث بالاسم أو الملاحظة أو المرجع",
    noResults: "لا توجد عمليات مطابقة",
    receipt: "الإيصال",
    reference: "المرجع",
    balanceAfter: "الرصيد بعد العملية",
    downloadReceipt: "طباعة / حفظ PDF",
    unverifiedBadge: "غير موثّق",
    verifiedBadge: "موثّق",
    adminOverview: "نظرة عامة",
    usersTotal: "المستخدمون",
    usersNew7d: "جدد (7 أيام)",
    liability: "إجمالي أرصدة المحافظ",
    volume30d: "الحركة (30 يوماً)",
    topups30d: "الشحن (30 يوماً)",
    pendingPayments: "مدفوعات معلّقة",
    auditLog: "سجل التدقيق",
    lastUpdated: "آخر تحديث",
  },
  en: {
    dir: "ltr",
    brand: "SbPay",
    tagline: "Your Fast & Secure Digital Wallet",
    signInGoogle: "Sign in with Google",
    signingIn: "Signing in...",
    loginBullet1: "Send & receive money instantly",
    loginBullet2: "Pay seamlessly with QR codes",
    loginBullet3: "Track every transaction in one place",
    currency: "SAR",
    balance: "Available Balance",
    walletNumber: "Wallet Number",
    hide: "Hide",
    show: "Show",
    send: "Send",
    request: "Request",
    add: "Add",
    scan: "Scan QR",
    quickActions: "Quick Actions",
    recentActivity: "Recent Activity",
    viewAll: "View all",
    noActivity: "No activity yet",
    noActivitySub: "Start by adding money or sending to a friend",
    myCard: "My Card",
    sbpayCard: "SbPay Card",
    addMoney: "Add Money",
    addMoneyDesc: "Add funds to your wallet securely",
    amount: "Amount",
    enterAmount: "Enter amount",
    confirm: "Confirm",
    cancel: "Cancel",
    sendMoney: "Send Money",
    sendMoneyDesc: "Send to any user by handle or mobile number",
    recipient: "Recipient",
    recipientPlaceholder: "@handle or mobile number",
    note: "Note (optional)",
    notePlaceholder: "e.g. Lunch, rent...",
    requestMoney: "Request Money",
    requestMoneyDesc: "Ask another user for an amount to approve",
    requestFrom: "Request from",
    scanToPay: "Scan to Pay",
    scanToPayDesc: "Enter the user handle from their QR to pay them",
    myQr: "My QR Code",
    receiveTab: "Receive",
    payTab: "Pay",
    qrReceiveDesc: "Let others scan this to send you money",
    copyHandle: "Copy handle",
    copied: "Copied",
    pendingRequests: "Pending Requests",
    requestedFromYou: "requested from you",
    pay: "Pay",
    decline: "Decline",
    requestsYouSent: "Requests You Sent",
    status_pending: "Pending",
    status_approved: "Paid",
    status_declined: "Declined",
    logout: "Log out",
    profile: "Profile",
    mobileNumber: "Mobile Number",
    mobilePlaceholder: "05XXXXXXXX",
    save: "Save",
    transactionDetails: "Transaction Details",
    type_topup: "Wallet Top-up",
    type_send: "Money Sent",
    type_receive: "Money Received",
    type_request_pay: "Request Payment",
    date: "Date",
    reference: "Reference",
    to: "To",
    from: "From",
    completed: "Completed",
    sent: "Sent",
    received: "Received",
    toastSent: "Money sent successfully",
    toastTopup: "Wallet topped up successfully",
    toastRequested: "Request sent",
    toastPaid: "Paid successfully",
    toastDeclined: "Request declined",
    toastHandleCopied: "Handle copied",
    toastProfileSaved: "Profile saved",
    errorGeneric: "Something went wrong",
    greeting: "Welcome",
    payByCard: "Pay by Card",
    instantDemo: "Instant (Demo)",
    cardTopupDesc: "Choose an amount and pay with mada, Visa or Mastercard",
    redirecting: "Redirecting to payment...",
    processingPayment: "Confirming your payment...",
    paymentSuccess: "Payment Successful",
    paymentSuccessDesc: "Your balance has been topped up",
    paymentCancelled: "Payment Cancelled",
    paymentCancelledDesc: "No payment was made",
    backToWallet: "Back to Wallet",
    more: "More",
    bills: "Bills",
    recharge: "Recharge",
    split: "Split Bill",
    billsRecharge: "Bills & Recharge",
    billsDesc: "Pay your bills or recharge mobile from your wallet",
    selectBiller: "Select provider",
    accountNumber: "Account / Mobile number",
    accountNumberPlaceholder: "Enter account or mobile number",
    toastBillPaid: "Bill paid successfully",
    toastRecharged: "Mobile recharged successfully",
    category_telecom: "Telecom",
    category_utility: "Utility",
    category_internet: "Internet",
    type_bill: "Bill Payment",
    type_recharge: "Mobile Recharge",
    splitBillTitle: "Split Bill",
    splitDesc: "Split a bill with friends and request each their share",
    splitTitlePlaceholder: "e.g. Dinner, trip...",
    totalAmount: "Total amount",
    participants: "Participants",
    addParticipantPlaceholder: "@handle or mobile number",
    addBtn: "Add",
    includeMe: "Include me in the split",
    perPerson: "Per person",
    sendRequests: "Send Requests",
    toastSplitSent: "Split requests sent",
    orDivider: "or",
    phoneLogin: "Sign in with mobile",
    enterPhoneTitle: "Enter your mobile",
    enterPhoneDesc: "We'll send you a one-time code",
    phonePlaceholder: "05XXXXXXXX",
    sendCode: "Send Code",
    enterCodeTitle: "Enter verification code",
    enterCodeDesc: "Enter the 6-digit code",
    verifyCode: "Verify & Sign in",
    resendCode: "Resend code",
    changeNumber: "Change number",
    demoCodeHint: "Your demo code",
    backToGoogle: "Back",
    continueWithEmail: "Continue with email",
    loginTab: "Sign in",
    registerTab: "Create account",
    fullName: "Full name",
    emailLabel: "Email",
    passwordLabel: "Password",
    namePlaceholder: "Enter your name",
    emailPlaceholder: "you@example.com",
    passwordPlaceholder: "At least 6 characters",
    signInBtn: "Sign in",
    registerBtn: "Create account",
    downloadStatement: "Download statement (CSV)",
    toastStatementReady: "Statement downloaded",
    autoReload: "Monthly auto-reload",
    autoReloadDesc: "Top up your wallet automatically every month",
    autoReloadAmount: "Monthly top-up amount",
    toastAutoReloadSaved: "Auto-reload setting saved",
    bankTransfer: "Bank Transfer",
    bankTransferDesc: "Send to any Saudi bank account via IBAN",
    selectBank: "Select bank",
    beneficiaryName: "Beneficiary name",
    beneficiaryPlaceholder: "Name as on the bank account",
    ibanLabel: "IBAN",
    ibanPlaceholder: "SA00 0000 0000 0000 0000 0000",
    transferBtn: "Transfer",
    toastBankTransfer: "Bank transfer submitted (processing)",
    type_bank_transfer: "Bank Transfer",
    status_processing: "Processing",
    myIban: "My wallet IBAN",
    nationalId: "National ID",
    nationalIdPlaceholder: "1xxxxxxxxx",
    mobileOptional: "Mobile number (optional)",
    cardControls: "Card Controls",
    cardControlsDesc: "Freeze your card or set a daily spending limit",
    freezeCard: "Freeze card",
    freezeCardDesc: "Temporarily block all card payments",
    cardFrozen: "Card frozen",
    cardActive: "Card active",
    dailyLimit: "Daily spending limit",
    dailyLimitDesc: "Maximum you can spend in a single day",
    noLimit: "No limit",
    spentToday: "Spent today",
    remainingToday: "Remaining today",
    manageCard: "Manage",
    toastCardUpdated: "Card settings updated",
    internationalTransfer: "International Transfer",
    intlTransferDesc: "Send money abroad via a licensed remittance partner",
    destinationCountry: "Destination country",
    transferMethod: "Transfer method",
    recipientGets: "Recipient gets",
    transferFee: "Transfer fee",
    totalDebit: "Total debit",
    sendAbroad: "Send abroad",
    toastIntlTransfer: "International transfer submitted (processing)",
    type_intl_transfer: "International Transfer",
    exchangeRate: "Exchange rate",
    insights: "Spending Insights",
    insightsDesc: "Your income and spending by category",
    income: "Income",
    spending: "Spending",
    net: "Net",
    noInsights: "No transactions in this period",
    txCount: "transactions",
    thisMonth: "This month",
    allTime: "All time",
    trackTransfer: "Track transfer",
    step_submitted: "Submitted",
    step_processing: "Processing",
    step_in_transit: "In transit",
    step_ready: "Ready for pickup",
    delivered: "Delivered",
    reference: "Reference",
    shareReceipt: "Share receipt",
    copyReceiptLink: "Copy receipt link",
    receiptCopied: "Receipt link copied",
    remittanceReceipt: "Remittance Receipt",
    estimatedArrival: "Estimated",
    setPin: "Set PIN",
    changePin: "Change PIN",
    cardPin: "Card PIN",
    cardPinDesc: "A 4-digit PIN protects your card actions",
    enterPin: "Enter PIN",
    currentPin: "Current PIN",
    newPin: "New PIN",
    confirmPin: "Confirm PIN",
    pinMismatch: "PINs do not match",
    revealCard: "Reveal card details",
    hideDetails: "Hide details",
    cardNumber: "Card number",
    expiry: "Expiry",
    cvv: "CVV",
    reissueCard: "Reissue card",
    reissueDesc: "Replace your current card number with a new one",
    reissueConfirm: "Reissue a new card? The current number will stop working.",
    unlockCard: "Enter your PIN to manage the card",
    toastPinSet: "Card PIN saved",
    toastReissued: "New card issued successfully",
    pinProtected: "PIN protected",
    sentVia: "via",
    amountSent: "Amount sent",
    poweredBy: "Powered by",
    txType: "Type",
    status: "Status",
    financing: "Instant Financing",
    financingDesc: "Get instant cash and repay over 4 months, 0% fees",
    financingBanner: "Instant cash up to 5,000 SAR",
    financingBannerSub: "Real-time Nafath check · 4 installments · 0% fees",
    chooseAmount: "Choose amount",
    chooseProvider: "Choose financing provider",
    applyNow: "Apply now",
    installmentsPlan: "4 monthly installments",
    zeroFee: "No fees",
    monthlyInstallment: "Monthly installment",
    nafathTitle: "Nafath verification",
    nafathInstruction: "Open the Nafath app and select this number to verify your identity",
    selectThisNumber: "Select this number in the Nafath app",
    verifying: "Verifying…",
    simulationMode: "Simulation mode (no live Nafath connection)",
    financingApproved: "Financing approved",
    cashAddedDesc: "The cash has been added to your wallet instantly",
    activeFinancing: "Active financing",
    noFinancing: "No active financing",
    newFinancing: "New financing",
    repay: "Repay",
    repayInstallment: "Repay installment",
    installment: "Installment",
    due: "Due",
    paidLabel: "Paid",
    remaining: "Remaining",
    allPaid: "All installments paid",
    financingRejected: "Verification could not be completed",
    tryAgain: "Try again",
    poweredByNafath: "Identity verified via Nafath",
    type_financing: "Financing",
    type_financing_repay: "Installment",
    accountType: "Account type",
    individual: "Individual",
    business: "Business",
    crNumber: "Commercial Registration (CR)",
    crPlaceholder: "10 digits",
    nafathVerifyNote: "Identity is verified via Nafath before your account is created",
    addToWallet: "Add to wallet",
    applePay: "Apple Pay",
    madaPay: "mada Pay",
    samsungWallet: "Samsung Wallet",
    added: "Added",
    toastWalletLinked: "Card added to wallet",
    adminPanel: "Customers",
    adminCustomers: "Customer Management",
    totalCustomers: "Total customers",
    searchCustomers: "Search by name, handle or ID",
    verifiedLabel: "Verified",
    unverifiedLabel: "Unverified",
    viewCustomers: "View customers",
    frozenLabel: "Frozen",
    navHome: "Home",
    financingShort: "Financing",
    navActivity: "Activity",
    navCard: "Card",
    navProfile: "Account",
    navAdmin: "Admin",
    comingSoon: "Soon",
    comingSoonDesc: "This service isn't available yet. We'll switch it on once it's connected to a licensed partner.",
    testMode: "Test mode",
    testModeNote: "Card top-ups run in test mode. No real money is charged.",
    topupNotConfigured: "Card top-up isn't available yet",
    topupNotConfiguredDesc: "No payment gateway is connected yet. You can still receive money from other SB Pay users.",
    payWithPayPal: "PayPal",
    paypalNote: "Charged in USD (1 USD = 3.75 SAR)",
    servicesTitle: "Services",
    loadError: "Couldn't load your data",
    retry: "Retry",
    loadMore: "Load more",
    filterAll: "All",
    filterIn: "In",
    filterOut: "Out",
    searchActivity: "Search name, note or reference",
    noResults: "No matching transactions",
    receipt: "Receipt",
    reference: "Reference",
    balanceAfter: "Balance after",
    downloadReceipt: "Print / save PDF",
    unverifiedBadge: "Unverified",
    verifiedBadge: "Verified",
    adminOverview: "Overview",
    usersTotal: "Users",
    usersNew7d: "New (7 days)",
    liability: "Total wallet balances",
    volume30d: "Outflow (30 days)",
    topups30d: "Top-ups (30 days)",
    pendingPayments: "Pending payments",
    auditLog: "Audit log",
    lastUpdated: "Updated",
  },
};

export const formatSAR = (amount, lang) => {
  const n = Number(amount || 0).toLocaleString(lang === "ar" ? "ar-SA" : "en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return n;
};
